import type { ApproverIdType } from '@this/domain/department/department/department';
import type { ApproverArgs } from '@this/domain/approver/approver';
import Approver from '@this/domain/approver/approver';
import { observable } from 'mobx';
import type { WorkflowResponseArgs } from '@this/domain/workflow/workflow';
import Workflow, { convertWorkflowResponseToArgs } from '@this/domain/workflow/workflow';

export type ApprovalAuthorityResponseArgs = {
  workflow?: WorkflowResponseArgs;
  workflow_id?: number;
  approve_stage: number;
  approver_id?: ApproverIdType;
  approver?: ApproverArgs;
};

export type ApprovalAuthorityArgs = {
  workflow?: Workflow;
  workflowId?: number;
  approveStage: number;
  approverId?: ApproverIdType;
  approver?: Approver;
};

export const convertApprovalAuthorityResponseToArgs = (
  response: ApprovalAuthorityResponseArgs
): ApprovalAuthorityArgs => {
  return {
    workflow: response.workflow ? new Workflow(convertWorkflowResponseToArgs(response.workflow)) : undefined,
    workflowId: response.workflow_id,
    approveStage: response.approve_stage,
    approverId: response.approver_id,
    approver: response.approver ? new Approver(response.approver) : undefined
  };
};

export default class ApprovalAuthority {
  @observable
  workflow?: Workflow;

  @observable
  workflowId?: number;

  @observable
  approveStage: number;

  @observable
  approverId?: ApproverIdType;

  @observable
  approver?: Approver;

  constructor(args: ApprovalAuthorityArgs) {
    this.workflow = args.workflow;
    this.workflowId = args.workflowId;
    this.approveStage = args.approveStage;
    this.approverId = args.approverId;
    this.approver = args.approver;
  }
}
